export default {
    activeLoading: ({ commit }, payload) => {
        commit('activeLoading', payload)
    },
    toggleSidebar: ({ commit }, payload) => {
        commit('toggleSidebar', payload)
    },
    changeSidebarState: ({ commit }, payload) => {
        commit('changeSidebarState', payload)
    },
    StoreNumber: ({ commit }, payload) => {
        commit('StoreNumber', payload)
    },
    StoreEmail: ({ commit }, payload) => {
        commit('StoreEmail', payload)
    },
    StoreGuestNumber: ({ commit }, payload) => {
        commit('StoreGuestNumber', payload)
    },
    StoreUserData: ({ commit }, payload) => {
        commit('StoreUserData', payload)
    },
    StoreAuthStatus: ({ commit }, payload) => {
        commit('StoreAuthStatus', payload)
    },
    StoreRealTimePrices: ({ commit }, payload) => {
        commit('StoreRealTimePrices', payload)
    },
    notificationCount: ({ commit }, payload) => {
        commit('notificationCount', payload)
    },
    StoreNotifications: ({ commit }, payload) => {
        commit('StoreNotifications', payload)
    },
    StoreSetting: ({ commit }, payload) => {
        commit('StoreSetting', payload)
    },
    StoreBankAccounts: ({ commit }, payload) => {
        commit('StoreBankAccounts', payload)
    },
    StoreWallets: ({ commit }, payload) => {
        commit('StoreWallets', payload)
    },
    StorePrice: ({ commit }, payload) => {
        commit('StorePrice', payload)
    },
    UserLogout: ({ commit }) => {
        commit('UserLogout')
    },
}